import React, { useState, useEffect, useRef, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, CircularProgress, Link, Box, IconButton } from "@mui/material";
import { Formik, Form, Field } from "formik";
import useAppDialog from "../../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../Dialog/dialogTypes";
import { useParams } from "react-router-dom";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

import * as Yup from "yup";


import useAuth from "../../context/AuthProvider";

import { apiClient } from "../../helper/api";
import { isMiscUser, isUserRoleInclude } from "../../helper/utils";
import { isStaffUser } from "../../helper/utils";
import DOMPurify from 'dompurify';
import { UploadedDocumentType } from "../../models/TaxTransactionReportModel";
import Tooltip from '@mui/material/Tooltip';
import Swal from "sweetalert2";
import { AddDocument } from "../../CustomerPanel/AddDocuments";
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce'
import moment from 'moment';
import { CustomerPolicyDetailsModel } from "../../models/CustomerPolicyDetailsModel";
interface MessageDialogProps {
  open: boolean,
  custPolicyID: string,
  viewOnly?: boolean,
  onSubmit?: (val?: any) => void,
  onClose?: () => void,
}

interface MessageProps {
  customerpolicyid: string,
  messageId: string,
  createdBy: string,
  messageType: string,
  message: string,
  createdByName: string,
  isRead: string,
  isEdited: string,
  isDeleted: string,
  dateCreated: string,
  dateModified: string,
  isResponse: string,
  filerName : string,
  createdByRoleId: number,
  roleName: string,
}

interface RequiredDocument {
  srdmId: number;
  documentName: string;
  isRequired: boolean;
}

 const MessageDialog: React.FC<MessageDialogProps> = ({ open, custPolicyID, viewOnly = false, onSubmit, onClose }) => {
  const [messages, setMessages] = useState<MessageProps[]>([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ reply: string }>({ reply: "" });
  const [UploadedDocument, setUploadedDocument] = useState<UploadedDocumentType[]>([]);
  const [revertedDocument, setRevertedDocument] = React.useState<UploadedDocumentType[]>([]);
  const [openDoc, setOpenDoc] = useState(false);
  const [itemList, setItemList] = useState<RequiredDocument[]>([]);
  const [policyDetail, setPolicyDetail] = useState<CustomerPolicyDetailsModel>({});
  // const [loading, setloading] = useState(true);
  const params = useParams();
  const { openDialog_Message } = useAppDialog()
  const [getPolicyStatus, setPolicyStatus] = React.useState<string>('');
  const { user } = useAuth();
  const token = user?.token;
  const sanitizeHTML = (html: any) => DOMPurify.sanitize(html);

  const [revertDocument, setRevertDocument] = useState<{ documentTypeId: number; customerPolicyDocumentId: number; isRevert: boolean}[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
const validationSchema = Yup.object({
    reply: Yup.string().required("Reply is required"),
  });

  const UploadDocument = () => {
    setOpenDoc(true);
  }

  const handleClose = () => {
    getUploadedDocuments()
    fetchRequiredDocument()
    setOpenDoc(false)
  };
  

  const getUploadedDocuments = () => {
    apiClient(`/customer/getUploadedDocuments?customerPolicyId=${custPolicyID}`,
      {
        method: "GET",
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        })
             }).then((res) => {
         try {
           if (!res) {
             setUploadedDocument([]);
             return;
           }
           
           if (res && res.data && Array.isArray(res.data)) {
             setUploadedDocument(res.data);
           } else {
             setUploadedDocument([]);
           }
         } catch (error) {
           console.error('Error processing uploaded documents response:', error);
           setUploadedDocument([]);
         }
       })
  }
  const getRevertedDocuments = () => {
    setLoading(true)
    return apiClient(`/customer/getRevertedDocuments?customerPolicyId=${custPolicyID}`,
    {
        method: "GET",
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        })
    }).then((res) => {
        if (!res || !res.data || !Array.isArray(res.data)) {
            setRevertedDocument([]);
            setLoading(false);
            return;
        }
        setRevertedDocument(res.data.filter((item: UploadedDocumentType) => item.documentTypeId != 0));
        setLoading(false)
    }).catch((error) => {
        setRevertedDocument([]);
        setLoading(false);
    })
}
  const handleSendMessage = async (CustomerPolicyId: number, status: string) => {
    try {
        setLoading(true);
        openDialog_Message({
            custPolId: String(CustomerPolicyId)
        }).then((res: DialogResponse) => {
            if (res.dialogResult === DialogResult.OK) {
  
            }
            return res
        })
        setLoading(false);
    } catch (error) {
        setLoading(false);
    }
  };
  function RevertDocument(
    documentTypeId: number,
    documentName: string | undefined,
    customerPolicyDocumentId: number
  ) {
    const isRevertExist = revertDocument.some((val) => val.documentTypeId === documentTypeId);
    if (!isRevertExist || true) {
        setRevertDocument((prev) => [...prev,  { documentTypeId, customerPolicyDocumentId, isRevert: true},]);
    } else {
        setRevertDocument((prev) =>
            prev.filter((val) => val.documentTypeId !== documentTypeId || val.customerPolicyDocumentId !== customerPolicyDocumentId)
        );
    }
  }
     const handleRevert = async (documentDetails: any, isAll: boolean) => {
     Swal.fire({
         title:  'Send Back to Client',
         text: `Are you sure you want to Send Back to Client ?`,
         icon: 'question',
         showCancelButton: true,
         confirmButtonColor: '#007BFF',
         cancelButtonColor: '#6c757d',
         confirmButtonText: 'Confirm',
         cancelButtonText: 'Cancel',
         padding: '20px',
         backdrop: true,
         customClass: {
             popup: 'custom-swal-popup',
             confirmButton: 'btn-radius',
             cancelButton: 'btn-radius',
         },
         width: '500px',
     })
     .then(async (result) => {
         if (result.isConfirmed) {
             try {
                 setLoading(true);
                 
                 // Extract customerPolicyDocumentIds from documentDetails
                 const customerPolicyDocumentIds = documentDetails
                     .map((doc: any) => doc.customerPolicyDocumentId)
                     .join(',');
                 
                 // Create payload for the new API
                 const payload = {
                     customerPolicyDocumentIds: customerPolicyDocumentIds,
                     customerPolicyId: Number(custPolicyID)
                 };
                 
                 console.log('Reverting documents with payload:', payload);
                 
                                   const res = await apiClient(`/customer/revertAllDocuments`, {
                      method: 'POST',
                      headers: new Headers({
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`,
                      }),
                      body: JSON.stringify(payload)
                  });
                 
                 if (res.resp == 0 || res.status === true) {
                     Swal.fire({
                         title: 'Success',
                         text: 'Documents have been sent back to client.',
                         icon: 'success',
                         confirmButtonColor: '#3085d6',
                         confirmButtonText: 'OK'
                     });
                     
                     // Clear revert state
                     setRevertDocument([]);
                     
                     // Refresh the uploaded and reverted documents to show the updated state
                     setTimeout(() => {
                         getUploadedDocuments();
                         getRevertedDocuments();
                     }, 500);
                     
                     // Send message after successful revert
                     if (custPolicyID && custPolicyID !== 'undefined' && custPolicyID !== 'null' && custPolicyID !== '') {
                         handleSendMessage(Number(custPolicyID), "Waiting on Client");
                     }
                 } else {
                     Swal.fire({
                         title: 'Error',
                         text: res.message || 'Failed to revert documents',
                         icon: 'error',
                         confirmButtonColor: '#dc3545',
                         confirmButtonText: 'OK'
                     });
                 }
             } catch (error: any) {
                 console.error('Error reverting documents:', error);
                 Swal.fire({
                     title: 'Error',
                     text: `Failed to revert documents: ${error?.message || 'Unknown error'}`,
                     icon: 'error',
                     confirmButtonColor: '#dc3545',
                     confirmButtonText: 'OK'
                 });
             } finally {
                 setLoading(false);
             }
         }
     });
 };
  const fetchRequiredDocument = () => {
    apiClient(`/customer/getRequiredDocuments?customerPolicyId=${custPolicyID}&all=0`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
             .then(responseJson => {
         try {
           if (responseJson && responseJson.data && Array.isArray(responseJson.data) && responseJson.data.length > 0) {
             setItemList(responseJson.data);
           } else {
             setItemList([]);
           }
         } catch (error) {
           console.error('Error processing required documents response:', error);
           setItemList([]);
         }
       })
      .catch(error => {
        setItemList([]);
        setLoading(false);
      });
  };

  const createMessage = async (reply: string) => {
     // Debug logging
     console.log('createMessage called with:', { custPolicyID, reply, type: typeof custPolicyID });
     
     // Validate customerPolicyId before sending
     if (!custPolicyID || custPolicyID === 'undefined' || custPolicyID === 'null') {
       console.error('Invalid custPolicyID:', custPolicyID);
       Swal.fire({
         title: 'Error',
         text: 'Invalid Customer Policy ID. Please refresh the page and try again.',
         icon: 'error',
         confirmButtonColor: '#dc3545',
         confirmButtonText: 'OK'
       });
       return;
     }

     const policyStatus = policyDetail.status || ''
     const homeState = policyDetail.homeState || ''
     if (!homeState) {
       // Show an error when the HomeState is not defined.
       console.error('Invalid HomeState:', homeState);
       Swal.fire({
         title: 'Error',
         text: 'Invalid Customer Home State. Please refresh the page and try again.',
         icon: 'error',
         confirmButtonColor: '#dc3545',
         confirmButtonText: 'OK'
       });
      return
     }

    //  const filerName = user?.userFirstName + ' ' + user?.userlastName

     const formData = new FormData();
     formData.append("customerPolicyId", custPolicyID.toString());
     formData.append("message", reply);
     formData.append("isResponse", 'true');
     formData.append("policyStatus", policyStatus)
     formData.append("homeState", homeState)
    //  formData.append("filerName", filerName)

     setLoading(true);
     await apiClient(`/messages/createMessage/`, {
       method: "POST",
       headers: new Headers({
         Authorization: `Bearer ${token}`,
       }),
       body: formData,
     }).then((res) => {
       if (!res) {
         Swal.fire({
           title: 'Error',
           text: 'No response received from server',
           icon: 'error',
           confirmButtonColor: '#dc3545',
           confirmButtonText: 'OK'
         });
         return;
       }
       
       if (res.status === false) {
         // Handle API error response
         Swal.fire({
           title: 'Error',
           text: res.message || 'Failed to send message',
           icon: 'error',
           confirmButtonColor: '#dc3545',
           confirmButtonText: 'OK'
         });
         return;
       }
       
       // Success case
       Swal.fire({
         title: 'Message Sent Successfully',
         text: res.data || 'Your message has been sent.',
         icon: 'success',
         confirmButtonColor: '#3085d6',
         confirmButtonText: 'OK'
       });
     }).catch((error) => {
       console.error('Error creating message:', error);
       Swal.fire({
         title: 'Error',
         text: 'Failed to send message. Please try again.',
         icon: 'error',
         confirmButtonColor: '#dc3545',
         confirmButtonText: 'OK'
       });
     }).finally(() => {
       setLoading(false);
     });
   }

  const handleSubmit = async (values: { reply: string }, { setSubmitting }: any) => {
    await createMessage(values.reply)
    
    setSubmitting(false);

    onSubmit?.(values.reply)
  };

  const fetchMessages = () => {
    apiClient(`/messages/getMessages?customerPolicyId=${custPolicyID}`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
      }),
    }).then((responseJson) => {
      try {
        if (!responseJson) {
          setMessages([]);
          return;
        }
        
        // Safely check the response structure
        const responseData = responseJson?.data;
        if (!responseData) {
          setMessages([]);
          return;
        }
        
        const messagesData = responseData.getMessages_Respdata;
        
        // Check if messagesData exists and is an array (any length is fine)
        if (messagesData && Array.isArray(messagesData)) {
          setMessages(messagesData);
        } else {
          setMessages([]);
        }
      } catch (error) {
        console.error('Error processing messages response:', error);
        setMessages([]);
      }
    }).catch((error) => {
      console.error('Error fetching messages:', error);
      setMessages([]); // Set empty messages on error
    }).finally(() => {
      setLoading(false); // Stop loading spinner
    });
  }

  const fetchPolicyDetail = () => {
    apiClient(`/PolicyDashBoard/getCustomerPolicyDetails?customerPolicyId=${custPolicyID}`,{
      method: "GET",
      headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
      })
    }).then((res) => {
      if (!res) return
      console.log(res?.data)
      setPolicyDetail(res?.data)
    })
  }

     useEffect(() => {
     if (!open) {
       setMessages([]);
       return;
     }

     // Debug logging for custPolicyID
     console.log('useEffect triggered with custPolicyID:', custPolicyID, 'type:', typeof custPolicyID);

     setLoading(true);
     getUploadedDocuments();
     getRevertedDocuments();
     fetchRequiredDocument();
     fetchMessages();
     fetchPolicyDetail();
   }, [open, custPolicyID]);

  const isReply = () => {
    if (isStaffUser(user?.userRoles)) {
      return true
    } else {
      return messages[0]?.isResponse ? true : false
    }
  }

  const isUserMessage = (userId: any) => user?.userId.toString() === userId.toString() ? true : false

  const isAdminMessage = (message: MessageProps) => {
    // Admin role IDs: 1,6,8,9,10,11 are client roles, so admin messages are NOT these
    const clientRoleIds = [1, 6, 8, 9, 10, 11];
    return !clientRoleIds.includes(message.createdByRoleId);
  }

  // Helper function to determine if user can delete documents (admin or client users)
  const canDeleteDocuments = () => {
    if (!user?.userRoles) return false;
    const roles = user.userRoles.split(",");
    return roles.some(role => 
      ['Super Admin', 'Client Admin', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
    );
  };

  // Helper function to display MISC user names as "miscstaff" for client users
  const getDisplayName = (uploadedBy: string, uploadedByRoleId?: number) => {
    if (!user?.userRoles) return uploadedBy || '-';
    
    const roles = user.userRoles.split(",");
    const isClientUser = roles.some(role => 
      ['Customer User', 'Client Admin', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
    );
    if (isClientUser) {
      const clientRoleIds = [8, 9, 10, 11];
      return clientRoleIds.includes(uploadedByRoleId || 0) ? uploadedBy || '-' : 'miscstaff';
    } else {
      return uploadedBy || '-';
    }
  }

  const groupedRows = useMemo(() => {
    // Group uploaded documents
    const uploadGroups = new Map<string, UploadedDocumentType[]>();
    UploadedDocument.forEach((doc) => {
      const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
      const key = `${doc.blob_Address}::${fileName}`;
      const arr = uploadGroups.get(key) || [];
      arr.push(doc);
      uploadGroups.set(key, arr);
    });

    // Group reverted documents
    const revertGroups = new Map<string, UploadedDocumentType[]>();
    revertedDocument.forEach((doc) => {
      const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
      const key = `${doc.blob_Address}::${fileName}`;
      const arr = revertGroups.get(key) || [];
      arr.push(doc);
      revertGroups.set(key, arr);
    });

    // Process uploaded documents (latest first)
    const uploadedRows = Array.from(uploadGroups.values()).map((docs, idx) => {
      const first = docs[0] as any;
      const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
      const docTypeNames = Array.from(new Set(
        docs.map((d) => (d as any).name).filter(Boolean)
      )).join(', ');
      const uploadedAt = first.dateUploadedAt ? moment.utc(first.dateUploadedAt).local().format('MM/DD/YYYY HH:mm') : '-';
      const uploadedBy = getDisplayName(first.uploadedByFullName || first.uploadedBy || '-', first.uploadedByRoleId);
      const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
      const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
      
      return { 
        first, 
        fileName, 
        docTypeNames, 
        allDocuments: docs,
        uploadedAt, 
        uploadedBy, 
        sizeText, 
        pagesText,
        isReverted: false
      };
    }).sort((a, b) => new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime());

    // Process reverted documents (latest first)
    const revertedRows = Array.from(revertGroups.values()).map((docs, idx) => {
      const first = docs[0] as any;
      const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
      const docTypeNames = Array.from(new Set(
        docs.map((d) => (d as any).name).filter(Boolean)
      )).join(', ');
      const uploadedAt = first.dateUploadedAt ? moment.utc(first.dateUploadedAt).local().format('MM/DD/YYYY HH:mm') : '-';
      const uploadedBy = getDisplayName(first.uploadedByFullName || first.uploadedBy || '-', first.uploadedByRoleId);
      const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
      const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
      
      return { 
        first, 
        fileName, 
        docTypeNames, 
        allDocuments: docs,
        uploadedAt, 
        uploadedBy, 
        sizeText, 
        pagesText,
        isReverted: true
      };
    }).sort((a, b) => new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime());

    // Return uploaded documents first, then reverted documents
    return [...uploadedRows, ...revertedRows];
  }, [UploadedDocument, revertedDocument, user]);



  const handleDeleteMessage = (message: MessageProps) => {
    
    Swal.fire({
      title: 'Are you sure, you want to delete this message?',
      // text: "You won't be able to revert this!",
      // icon: null, // Remove the icon property
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true)
        apiClient("/messages/deleteMessageById?messageId=" + `${message.messageId}`,
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            }),
            method: "Delete",
          }
        ).then((res) => {
          if (!res) return
          if (res.data == "success") {
            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success')
              .then(() => {
                //  goBack();
                // fetchData();
              }
            )
          }
          // setOpen(false);
        }).finally(() => {
          setMessages(v => v.filter(m => m.messageId !== message.messageId))
          setLoading(false);
        });
      }
      setLoading(false);
    })
  }

  const handleDeleteDocument = async (rowData: any) => {
    const resDlg = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    });

    if (!resDlg.isConfirmed) {
      return;
    }

    setLoading(true);
    try {
      // Delete all documents in this row
      const deletePromises = rowData.allDocuments.map((doc: UploadedDocumentType) => 
        apiClient(`/customer/DeleteUploadedDocument?customerPolicyDocumentId=${doc.customerPolicyDocumentId}`, {
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }),
          method: "Delete",
        })
      );

      await Promise.all(deletePromises);

      // Refresh data after successful deletion
      await Promise.all([
        getUploadedDocuments(),
        getRevertedDocuments(),
        fetchRequiredDocument()
      ]);

      Swal.fire({
        icon: 'success',
        title: 'Deleted Successfully!',
        text: `The file "${rowData.fileName}" and its document types have been successfully deleted.`,
        confirmButtonText: 'OK'
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Delete Failed',
        text: 'Some documents could not be deleted. Please try again.',
        confirmButtonText: 'OK'
      });
    } finally {
      setLoading(false);
    }
  }

  function ViewDocuments(props: { item: UploadedDocumentType }) {
    const { item } = props;

    return (
      <div className="box-style col-lg-12">
        <div style={{ marginTop: "8px" }}>
          <Tooltip
            title={`Download ${item.documentName}`}
            arrow
          >
            <Link
              href={item.blob_Address}
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
              }}
              target="_blank"
            >
              <div
                role="presentation"
                tabIndex={0}
                style={{
                  flex: "1 1 0%",
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                  borderWidth: "1px",
                  borderRadius: "8px",
                  borderColor: "rgb(65, 114, 159)",
                  borderStyle: "dashed",
                  backgroundColor: "rgb(250, 250, 250)",
                  color: "rgb(65, 114, 159)",
                  outline: "none",
                  transition: "border 0.24s ease-in-out",
                  cursor: "pointer",
                }}
              >
                <span style={{ marginRight: "8px" }}>
                  <p style={{ margin: 0 }}>{item.name}</p>
                </span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75M6.41667 9.16667L11 13.75M11 13.75L15.5833 9.16667M11 13.75V2.75"
                    stroke="#02A4E3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </Link>
          </Tooltip>
          
        {/* Document name display */}
        <div style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}>
          <p
            style={{
              height: "20px",
              textAlign: "start",
              margin: "2px 0",
              color: "#555",
              fontSize: "0.9rem",
            }}
          >
            {item.documentName}
          </p>
          <div>
            <p style={{ marginTop: "2px", textAlign: 'start' }}>Date Uploaded: {item.dateUploadedAt ? moment.utc(item.dateUploadedAt).local().format('MM/DD/YYYY HH:mm') : ''}
            </p>
          </div>
        </div>

        {/* Document type with download link at the bottom */}
        </div>
      </div>
    );
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={false} // Disable max-width restrictions
        PaperProps={{
          style: {
            width: '95%', // 90% of the viewport width
            height: '95%', // 90% of the viewport height
            margin: 'auto', // Center it on the screen
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: "#e8f5fe" }}>
          <DialogTitle style={{ color: "#1976D2", fontSize: '25px' }}>
              INBOX
          </DialogTitle>
          {!!policyDetail.policyNumber && <span style={{ fontSize: '20px', padding: '16px 24px' }}>{`Policy Number: ${policyDetail.policyNumber}`}</span>}
        </Box>
        <DialogContent style={{ backgroundColor: "#f4f9fc" }}>
          <Formik
            initialValues={message}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={handleSubmit}
          >
            {({ values, isSubmitting, handleChange, errors, touched }) => (
              <Form style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <div style={{ display: "flex", gap: "20px", flex: "1", padding: "10px 0", height: "65%" }}>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ color: "#00A9E0", marginBottom: "22PX", fontWeight: "bold", fontSize: '20px' }}>MESSAGE</h3>
                    <div
                      style={{
                        height: "91%", // Set a fixed height for the scrollable area
                        overflowY: "auto", // Enable vertical scrolling
                        border: "1px solid #ddd", // Add border for clarity
                        padding: "10px",
                        borderRadius: "4px",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          {messages && messages?.length > 0 ? (
                            messages.map((message, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    verticalAlign: "top",
                                    borderBottom: "1px solid #ddd",
                                  }}
                                >
                                  {(() => {
                                     if (user?.userRoles.split(",").includes("Customer User") ||
                                          user?.userRoles.split(",").includes("Client Admin") ||
                                          user?.userRoles.split(",").includes("Client Accounting") ||
                                          user?.userRoles.split(",").includes("Client Operations") ||
                                          user?.userRoles.split(",").includes("Client Processors")) {
                                            // [1,6,8,9,10,11] These IDs belong to the Client Roles across all environments.
                                          return [1,6,8,9,10,11].includes(message.createdByRoleId) ? message.createdByName || "Unknown" : "miscstaff";
                                     }else{
                                          return message.createdByName || "Unknown";
                                     }
                                  })()}
                                </td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                                  {/* Render HTML content or plain text */}
                                  {/* {message.message ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: message.message,
                                      }}
                                      style={{
                                        fontSize: "0.9rem",
                                        color: "#333",
                                        lineHeight: "1.5",
                                      }}
                                    />
                                  ) : (
                                    <span>No message content</span>
                                  )} */}
                                  <div
                                    style={{
                                      fontSize: "0.9rem",
                                      color: "#333",
                                      lineHeight: "1.5",
                                      maxWidth: "100%",
                                      overflowX: "auto",
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {message.message ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: sanitizeHTML(message.message),
                                        }}
                                        style={{
                                          overflowX: "auto",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          maxWidth: "100%",
                                        }}
                                      />
                                    ) : (
                                      <span>No message content</span>
                                    )}
                                  </div>
                                  <br />
                                  {/* Render the date */}
                                   <span style={{ fontSize: "0.85em", color: "#888" }}>
                                     {message.dateModified
                                       ? new Date(`${message.dateModified}`).toLocaleString('en-US', {
                                           year: 'numeric',
                                           month: '2-digit',
                                           day: '2-digit',
                                           hour: '2-digit',
                                           minute: '2-digit',
                                           second: '2-digit'
                                         })
                                       : "Unknown date"}
                                   </span>
                                </td>
                                
                                {(isUserRoleInclude(user?.userRoles.split(","), ["Super Admin"]) && isAdminMessage(message)) && <td style={{
                                  padding: "8px",
                                  borderBottom: "1px solid #ddd",
                                  width: "30px"
                                }}>
                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDeleteMessage(message)}
                                  >
                                    <svg width="30px" height="30px" viewBox="0 0 24 24" version="1.1">
                                      <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                        <g id="System" transform="translate(-576.000000, -192.000000)" fill-rule="nonzero">
                                          <g id="delete_2_line" transform="translate(576.000000, 192.000000)">
                                              <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path>
                                              <path d="M14.2792,2 C15.1401,2 15.9044,2.55086 16.1766,3.36754 L16.7208,5 L20,5 C20.5523,5 21,5.44772 21,6 C21,6.55227 20.5523,6.99998 20,7 L19.9975,7.07125 L19.9975,7.07125 L19.1301,19.2137 C19.018,20.7837 17.7117,22 16.1378,22 L7.86224,22 C6.28832,22 4.982,20.7837 4.86986,19.2137 L4.00254,7.07125 C4.00083,7.04735 3.99998,7.02359 3.99996,7 C3.44769,6.99998 3,6.55227 3,6 C3,5.44772 3.44772,5 4,5 L7.27924,5 L7.82339,3.36754 C8.09562,2.55086 8.8599,2 9.72076,2 L14.2792,2 Z M17.9975,7 L6.00255,7 L6.86478,19.0712 C6.90216,19.5946 7.3376,20 7.86224,20 L16.1378,20 C16.6624,20 17.0978,19.5946 17.1352,19.0712 L17.9975,7 Z M10,10 C10.51285,10 10.9355092,10.386027 10.9932725,10.8833761 L11,11 L11,16 C11,16.5523 10.5523,17 10,17 C9.48715929,17 9.06449214,16.613973 9.00672766,16.1166239 L9,16 L9,11 C9,10.4477 9.44771,10 10,10 Z M14,10 C14.5523,10 15,10.4477 15,11 L15,16 C15,16.5523 14.5523,17 14,17 C13.4477,17 13,16.5523 13,16 L13,11 C13,10.4477 13.4477,10 14,10 Z M14.2792,4 L9.72076,4 L9.38743,5 L14.6126,5 L14.2792,4 Z" id="形状" fill="#09244B"> </path>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                </td>}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "center", padding: "8px" }}>
                                No messages
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Right Side: Attachments - Hidden in view only mode */}
                  {!viewOnly && (
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3
                        style={{
                          color: "#00A9E0",
                          fontWeight: "bold",
                          fontSize: "20px",
                        }}
                      >
                        ATTACHMENTS
                      </h3>
                      <div style={{ display: "flex", gap: "10px" }}>
                         {!viewOnly && itemList?.length > 0 &&
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                UploadDocument();
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "10px 16px",
                                backgroundColor: "#1976D2",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                fontSize: "14px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                transition: "background-color 0.3s ease, transform 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#1565C0";
                                e.currentTarget.style.transform = "scale(1.05)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#1976D2";
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              Upload Document
                            </button>
                          }
                      </div>
                    </div>
                    <div
                        style={{
                          height: "91%", // Set a fixed height for the scrollable area
                          overflowY: "auto", // Enable vertical scrolling
                          border: "1px solid #ddd", // Add border for clarity
                          padding: "10px",
                          borderRadius: "4px",
                          textAlign: "center",
                        }}
                      >
                        <h3
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "25px",
                            display: "flex",
                            marginBottom: "15px",
                          }}
                        >
                          History :
                        </h3>
                         {/* DataGrid for show Document  */}
                         {groupedRows && groupedRows.length > 0 ? (
                           <Box sx={{ width: '100%', mb: 2 }}>
                             <DataGridPro
                               autoHeight
                               rows={groupedRows.map((r, idx) => ({
                                 id: `${r.first.customerPolicyDocumentId}-${idx}`,
                                 fileName: r.fileName,
                                 docTypeNames: r.docTypeNames,
                                 uploadedAt: r.uploadedAt,
                                 uploadedBy: r.uploadedBy,
                                 sizeText: r.sizeText,
                                 pagesText: r.pagesText,
                                 first: r.first,
                                 allDocuments: r.allDocuments,
                                 isReverted: r.isReverted
                               }))}
                               columns={([
                                 { field: 'fileName', headerName: 'File Name', flex: 1, minWidth: 200, renderCell: (params) => (
                                   <Link href={params.row.first.blob_Address} target="_blank" sx={{textAlign: 'initial',width: '100%', textDecoration: 'none', overflow: 'initial', whiteSpace: 'break-spaces',lineHeight:'normal' }}>{params.value || '-'}</Link>
                                 ) },
                                 { field: 'docTypeNames', headerName: 'Document Types', flex: 1, minWidth: 310, maxWidth: 400, renderCell: (params) => (
                                   <Box sx={{ textAlign: 'initial', width: '100%', overflow: 'initial', textOverflow: 'ellipsis', whiteSpace: 'break-spaces',lineHeight:'normal' }}>
                                     {params.value || '-'}
                                   </Box>
                                 ) },
                                 { field: 'uploadedAt', headerName: 'Upload Date', flex: 0.8, minWidth: 160 },
                                 { field: 'uploadedBy', headerName: 'Uploaded By', flex: 0.8, minWidth: 160 },
                                 { field: 'sizeText', headerName: 'File Size', flex: 0.6, minWidth: 120 },
                                 ...(canDeleteDocuments() ? [{
                                   field: 'actions', 
                                   headerName: 'Actions', 
                                   sortable: false, 
                                   filterable: false, 
                                   flex: 0.5, 
                                   minWidth: 120, 
                                   renderCell: (params: any) => (
                                     <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                       {/* Delete Button */}
                                       <Tooltip title="Delete Document" arrow>
                                         <IconButton 
                                           color="error" 
                                           onClick={() => {
                                             handleDeleteDocument(params.row)
                                           }}
                                         >
                                           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                           </svg>
                                         </IconButton>
                                       </Tooltip>
                                     </div>
                                   )
                                 }] : [])
                               ]) as GridColDef[]}
                               pagination
                               rowsPerPageOptions={[5, 10, 25]}
                               pageSize={rowsPerPage}
                               onPageSizeChange={(newPageSize: number) => setRowsPerPage(newPageSize)}
                               disableSelectionOnClick
                               disableColumnMenu
                               sx={{
                                 borderRadius: '10px',
                                 overflow: 'hidden',
                                 fontFamily: "'Proxima Nova', sans-serif",
                                 fontSize: '14px',
                                 '& .MuiDataGrid-main': {
                                   overflow: 'hidden'
                                 }
                               }}
                               getRowClassName={(params) => {
                                 return params.row.isReverted ? 'reverted-row' : '';
                               }}
                             />
                           </Box>
                         ) : (
                           <Box sx={{ 
                             width: '100%', 
                             textAlign: 'center', 
                             py: 4, 
                             color: '#666',
                             fontFamily: "'Proxima Nova', sans-serif",
                             fontSize: '16px'
                           }}>
                             No documents available
                           </Box>
                         )}
                    </div>
                  </div>
                  )}
                </div>

                {/* Reply Section - Hidden in view only mode */}
                {!viewOnly && (
                  <div style={{ flex: "0 0 auto", marginTop: "0", marginBottom: "0" }}>
                    <h3 style={{ color: "#00A9E0", marginBottom: "0", fontWeight: "bold", fontSize: '20px' }}>REPLY</h3>
                    <Field
                      as="textarea"
                      name="reply"
                      placeholder="Type your reply here..."
                      style={{
                        width: "100%",
                        height: "100px",
                        padding: "10px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontFamily: "Arial, sans-serif",
                      }}
                      value={message.reply}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleChange(e);
                        setMessage({ ...message, reply: e.target.value });
                      }}
                      disabled={(isReply() ? false : true)}
                    />
                    {isReply() && touched.reply && errors.reply && (
                      <p style={{ color: "red" }}>{errors.reply}</p>
                    )}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center", // Align checkbox and buttons vertically
                        marginTop: "20px",
                      }}
                    >

                      <button
                        type="button"
                        onClick={onClose}
                        style={{
                          marginRight: "10px",
                          padding: "10px 20px",
                          backgroundColor: "#E0E0E0",
                          color: "#000",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontWeight: "bold",
                        }}
                      >
                        Cancel
                      </button>

                      {/* Send & Return Button */}
                      <button
                        type="submit"
                        disabled={isSubmitting || !(values.reply?.trim?.() ?? '').length}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: (isSubmitting || !(values.reply?.trim?.() ?? '').length) ? "#A9A9A9" : "#1976D2",
                          color: "#fff",
                          border: "none",
                          cursor: (isSubmitting || !(values.reply?.trim?.() ?? '').length) ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontWeight: "bold",
                        }}
                      >
                        {isSubmitting ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          isStaffUser(user?.userRoles) ? "Send & Return" : "Send"
                        )}
                      </button>
                    </div>
                  </div>
                )}
                {/* Close button for view only mode */}
                {viewOnly && (
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                    <button
                      type="button"
                      onClick={onClose}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#E0E0E0",
                        color: "#000",
                        border: "none",
                        cursor: "pointer",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                    >
                      Close
                    </button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
             {custPolicyID && custPolicyID !== 'undefined' && custPolicyID !== 'null' && custPolicyID !== '' && (
        <AddDocument open={openDoc} handleClose={handleClose} customerPolicyId={custPolicyID}></AddDocument>
       )}
    </>
  );
};

export default MessageDialog;